import React, { Component } from "react";
import "./Education.css";
import Header from "../../Hoc/Header";
import Footer from "../../Hoc/Footer";
import axios from "axios";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import {
  CollapsibleComponent,
  CollapsibleHead,
  CollapsibleContent,
} from "react-collapsible-component";
import filter from "../../../Assets/img/sort.png";
import Loader from "react-loader-spinner";
import deletee from "../../../Assets/img/deletee.png";
import { Link } from "react-router-dom";
import styles from "./Education.module.scss";
import { BiTimer } from "react-icons/bi";
import { BsGlobe } from "react-icons/bs";
import edu from "../../../Assets/img/edu.svg";

export default class Education extends Component {
  constructor() {
    super();
    this.state = {
      posts: [],
      majors: [],
      major: "",
      countrys: [],
      country: "",
      empty: false,
      loader: true,
      notFiltered: false,
    };
  }

  componentDidMount() {
    this.getPosts();
    this.getMajor();
    this.getCountry();
  }

  getPosts() {
    axios
      .get(
        `https://arianaapp.arianaapply.com/api/V1/show-select-time-studyOpportunity`
      )
      .then((res) => {
        console.log("gg", res);
        this.setState({ posts: res.data }, () => {
          this.setState({ loader: false, notFiltered: true });
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getCountry() {
  axios
    .get(`https://arianaapp.arianaapply.com/api/V1/show-country-filter`)
    .then((res) => {
      console.log("country", res);
      const countriesData = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data?.data)
        ? res.data.data
        : [];
      this.setState({ countrys: countriesData });
    })
    .catch((err) => {
      console.log(err);
      this.setState({ countrys: [] });
    });
}

  delete() {
    window.location.reload();
  }

  getMajor() {
  axios
    .get(`https://arianaapp.arianaapply.com/panel/show-all-major`)
    .then((res) => {
      console.log("major", res);
      // مطمئن شو که همیشه آرایه باشه
      const majorsData = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data?.data)
        ? res.data.data
        : [];
      this.setState({ majors: majorsData });
    })
    .catch((err) => {
      console.log(err);
      this.setState({ majors: [] });
    });
}

  onChange(e) {
    this.setState(
      {
        loader: true,
        notFiltered: false,
        [e.target.name]: e.target.value,
        empty: false,
      },
      () => {
        console.log(this.state.country);
        axios
          .get(
            `https://arianaapp.arianaapply.com/api/V1/show-select-country-studyOpportunity/${this.state.country}`
          )
          .then((res) => {
            if (res.data.length === 0) {
              this.setState({ empty: true, loader: false, notFiltered: false });
            } else {
              console.log("country-send", res);
              this.setState({
                posts: res.data,
                empty: false,
                loader: false,
                notFiltered: true,
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    );
  }

  onChangeMajor(e) {
    this.setState(
      {
        loader: true,
        notFiltered: false,
        [e.target.name]: e.target.value,
        empty: false,
      },
      () => {
        console.log(this.state.country);
        axios
          .get(
            `https://arianaapp.arianaapply.com/api/V1/show-select-major-studyOpportunity/${this.state.major}`
          )
          .then((res) => {
            if (res.data.length === 0) {
              this.setState({ empty: true, loader: false, notFiltered: false });
              console.log(res);
            } else {
              console.log("major-send", res);
              this.setState({
                posts: res.data,
                empty: false,
                loader: false,
                notFiltered: true,
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    );
  }

  renderItem(post) {
    const oneDay = 1000 * 60 * 60 * 24;
    const today = new Date();
    const deadline = new Date(post.deadline.toString());
    const differenceMs = Math.abs(today - deadline);
    const date = Math.round(differenceMs / oneDay);
    console.log("deadline", date);

    return (
      <>
        <div className={styles.eduBodyItem}>
          {
            <Link className={styles.link} to={`/education-single/${post._id}`}>
              <div className={styles.cardImg}>
                <img src={edu} alt="" />
              </div>
              <div className={styles.cardText}>
                <h2>{post.title_fa ? post.title_fa : post.title}</h2>
                <p>{post.responsibility}</p>
                <div className={styles.cardUnderItems}>
                  <div className={styles.cardUnderItem}>
                    <BsGlobe />
                    {post.country}
                  </div>
                  <div className={styles.cardUnderItem}>
                    {" "}
                    <BiTimer /> {date} روز{" "}
                  </div>
                </div>
              </div>
            </Link>
          }
        </div>
        {/* {<Link to={`/education-single/${post._id}`}>
            <div className="job-list-title-r" key={post._id}>
              <div className="job-list-text-fix">
                <h6>فرصت:{date}روز</h6> <h6>{post.country}</h6>
              </div>
              <h5>{post.title}</h5>
              <p className="two-line">{post.responsibility}</p>
            </div>

            <div className="job-list-title-icon">
              <img src={mortarboard} alt="JobSearch" />
            </div>
          </Link>} */}
      </>
    );
  }

  render() {
    const refreshPage = () => {
      window.location.reload();
    };
    return (
      <>
        <div className="pageWrapper">
          <Header title={`فرصت های تحصیلی`} />

          <div className="job-list">
            <div className="job-list-body-r">
              <div className="filter-body">
                <CollapsibleComponent>
                  <CollapsibleHead className="additionalClassForHead">
                    فیلتر <img src={filter} alt="Portfolio" />
                  </CollapsibleHead>

                  <CollapsibleContent className="additionalClassForContent">
                    <button className="delete-filter" onClick={refreshPage}>
                      پاک کردن <img src={deletee} alt="deletee" />{" "}
                    </button>
                    <div className="filter-select">
                      <span>فیلتر بر اساس کشور:</span>

                      <select
                        className="select-country"
                        onChange={this.onChange.bind(this)}
                        value={this.state.country}
                        name="country"
                      >
                        <option value="null">انتخاب کشور...</option>

                        {this.state.countrys.map((post) => (
                          <option value={post.country}>{post.country}</option>
                        ))}
                      </select>

                      <span>فیلتر بر اساس رشته:</span>
                      <select
                        className="select-country"
                        name="major"
                        onChange={this.onChangeMajor.bind(this)}
                        value={this.state.major}
                      >
                        <option value="#">انتخاب رشته...</option>

                        {this.state.majors.map((post) => (
                          <option value={post.major_fa}>{post.major_fa}</option>
                        ))}
                      </select>
                    </div>
                  </CollapsibleContent>
                </CollapsibleComponent>
              </div>

              {this.state.notFiltered === true ? (
                this.state.posts.map((post) => {
                  return this.renderItem(post);
                })
              ) : this.state.empty === true ? (
                <p className="not-found">نتیجه ای یافت نشد</p>
              ) : this.state.loader === true ? (
                <div className="spinner">
                  <Loader
                    type="TailSpin"
                    color="rgb(236, 177, 28)"
                    height={80}
                    width={80}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <Footer active="edu" />
      </>
    );
  }
}
